<template>
  <div class="box10">
    <pageTitle 
      title="认证考试内容" 
      text="线上动手实验+线下考场客观题考试"
      titleColor="#332114"
      titColor="#332114"
    />
    <div class="content">
      <ul class="info-list">
        <li v-for="(item, index) in list" :key="index" >
          <div class="top" @click="open(item)">
            <img :src="item.icon" alt="">
            <span>{{ item.title }}<span>{{ item.tit }}</span></span>
            <div class="open-btn" :class="{active: item.flag}"></div>
          </div>
          <div class="bottom bottom1" v-show="index === 0 && item.flag">
            <p v-for="(v1, i1) in item.info" :key="i1">
              <span>{{v1.title}}</span>
              {{v1.text}}
            </p>
          </div>
          <div class="bottom" v-show="index === 1 && item.flag">
            <img class="img1" src="../../../assets/coursePage/acp/box10/img1.png" alt="">
          </div>
          <div class="bottom" v-show="index === 2 && item.flag">
            <img class="img2" src="../../../assets/coursePage/acp/box10/img2.png" alt="">
          </div>
          <div class="bottom bottom4" v-show="index === 3 && item.flag">
            <div v-for="(item2, i1) in item.info" :key="i1">
              <h2>{{ item2.title }}</h2>
              <p v-for="(child, i2) in item2.children" :key="i2">{{ child }}</p>
            </div>
            <div class="btn-box">
              <div class="btn" @click="zixun(1,'查看完整考试大纲')">查看完整考试大纲</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import pageTitle from "../common/pageTitle.vue";
  export default {
    components: {
      pageTitle,
    },
    name: '',
    data() {
      return {
        list: [
        {
          icon: require('../../../assets/coursePage/acp/box10/icon-01.png'),
          title: '线上动手实验',
          tit: '（仅展示部分）',
          info: [
            {
              title: '实验一',
              text: '大数据ACP 在线直播课程实时监控'
            },
            {
              title: '实验二',
              text: '大数据ACP Hologres外表加速及点查询实践'
            },
            {
              title: '实验三',
              text: '大数据ACP 基于DataWorks进行海量日志数在线进行数据分析'
            }
          ],
          flag: false,
        },
        {
          icon: require('../../../assets/coursePage/acp/box10/icon-02.png'),
          title: '线下考场考试内容及占比',
          flag: false,
        },
        {
          icon: require('../../../assets/coursePage/acp/box10/icon-03.png'),
          title: '线下考场考试试卷类型',
          flag: false,
        },
        {
          icon: require('../../../assets/coursePage/acp/box10/icon-04.png'),
          title: '线上+线下认证考试内容范围',
          info: [
            {
              title: '大数据基础与阿里云大数据平台',
              children: [
                '了解大数据基本概念及当前大数据的发展趋势',
                '了解开源大数据平台经典架构、常用组件及其应用场景',
                '了解阿里云大数据产品体系、常用产品及应用场景'
              ]
            },
            {
              title: '大数据计算服务',
              children: [
                '了解MaxCompute的产品价值及产品架构',
                '熟悉MaxCompute的核心概念及常用开发工具',
                '熟悉MaxCompute常用的数据迁移工具',
                '掌握MaxCompute SQL的常用DDL、DML操作及内置函数的使用',
                '掌握MaxCompute SQL自定义函数的分类、开发及使用',
                '熟悉MaxCompute SQL性能调优的常用方法',
                '熟悉MaxCompute的权限及安全的管理'
              ]
            },
          ],
          flag: false,
        }
      ]
      }
    },
    methods:{
      open(item){
        this.list.forEach(val => {
          if(item.title === val.title){
            val.flag = !val.flag
          }else{
            val.flag = false
          }
        });
      },
      zixun(type,item){
        type==1?  this.mai("阿里云大数据ACP认证课","查看完成考试纲",0,null): this.mai("阿里云大数据ACP认证课",item,0,null)
        this.clickZiXun()
      }
    }
  }
</script>

<style lang="scss" scoped>
.box10{
  padding: 430px 0 60px;
  background-image: url(../../../assets/coursePage/acp/box10/bg.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
}  
.content {
  padding: 0 30px;
}
.info-list{
  margin-top: 50px;
  li{
    background-color: #ffffff;
    box-shadow: 0px 0px 30px 0px #f5e9dc;
    border-radius: 20px;
    margin-bottom: 30px;
    .top{
      padding: 28px 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      img{
        width: 64px;
        height: 64px;
      }
      span{
        flex: 1;
        font-family: PingFangSC-Medium;
        font-size: 30px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #332114;
        line-height: 64px;
        padding-left: 32px;
        span {
          font-size: 24px;
          padding: 0;
        }
      }
      .open-btn{
        width: 26px;
        height: 15px;
        background: url(../../../assets/coursePage/acp/box10/icon-down.png);
        background-size: 100% 100%;
        transition: all 0.2s;
        &.active{
          transform: rotate(180deg);
          
        }
      }
    }
    .bottom{
      padding: 30px 40px 40px;
      &.bottom1 {
        p{
          background-color: #ffffff;
          box-shadow: 0px 0px 30px 0px #f5e9dc;
          border-radius: 20px;
          font-family: SourceHanSansCN-Regular;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 32px;
          letter-spacing: 1px;
          color: #331f22;
          position: relative;
          padding: 30px 30px 24px;
          margin-bottom: 48px;
          span {
            position: absolute;
            display: block;
            width: 125px;
            height: 61px;
            background: url(../../../assets/coursePage/acp/box10/icon-sy.png) no-repeat;
            background-size: 100% 100%;
            top: -18px;
            left: 0;
            font-family: SourceHanSansCN-Heavy;
            font-size: 26px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 40px;
            letter-spacing: 1px;
            color: #ffffff;
            text-align: center;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      
      .img1, .img2 {
        width: 100%;
        height: auto;
      }
      &.bottom4 {
        padding-top: 0;
        h2 {
          font-family: PingFangSC-Medium;
          font-size: 26px;
          font-weight: 600;
          font-stretch: normal;
          line-height: 38px;
          letter-spacing: 0px;
          color: #332114;
          margin: 20px 0;
        }
        p {
          font-family: PingFangSC-Regular;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 40px;
          letter-spacing: 0px;
          color: #4d3f36;
          padding-left: 20px;
          position: relative;
          &::before {
            display: block;
            content: '';
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #ff8833;
            position: absolute;
            left: 0;
            top: 16px;
          }
        }
        .btn-box{
          margin-top: 40px;
          display: flex;
          justify-content: center;
          .btn{
            width: 360px;
            height: 60px;
            background-color: #ff6a00;
            border-radius: 30px;
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 60px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>